// 'Following feed' query will instantly crash if user follows more than 30 groups due to firebase limitations
const MAX_FOLLOW_COUNT = 30;

export default MAX_FOLLOW_COUNT;